import { Component, OnInit, Input, OnDestroy, OnChanges } from '@angular/core';
import { ActuationService } from '../../services/actuation.service';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import * as moment from 'moment';
import { ActuationOperation } from 'app/modules/common/enums/actuationOperation';
import Utils from 'app/Utils';

@Component({
    selector: 'app-trabajador-view-medico',
    templateUrl: './trabajador-view-medico.component.html',
    styleUrls: ['./trabajador-view-medico.component.scss'],
    standalone: false
})
export class TrabajadorViewMedicoComponent implements OnInit, OnDestroy, OnChanges {

    public gender: string;
    public birthDate;
    public age: number;
    public city: string;
    public formatedAddress: string;
    public yearDiffrence?: number = null;
    public monthDiffrence?: number = null;
    public textFollowedByYear: string = null;
    public textFollowedByMonth: string = null;
    public hiringAndContractEndDateToolTip: string;
    public BaajaDeeText: string;

    public consentToShow: string;
    public consent: string;
    public consentType: string;
    public consentimentoHouverText: string;

    public formatedTelephoneArray: string;
    public puesto: string;

    PermissionIds: Array<string>;
    DisplayEmployeeView = false;

    @Input() ActuationOperation: number;
    @Input("card-title") CardTitle = "Trabajador (Vista Médico)";

    constructor(public actuationService: ActuationService) { }

    ngOnChanges(): void {
        if (this.ActuationOperation) {
            if (
                this.ActuationOperation === Number(ActuationOperation.Visita) ||
                this.ActuationOperation === Number(ActuationOperation.Contacto) ||
                this.ActuationOperation === Number(ActuationOperation.PrimerContacto) ||
                this.ActuationOperation === Number(ActuationOperation.Comentarios) ||
                this.ActuationOperation === Number(ActuationOperation.ContactoAdministrativo)
            ) {
                this.SetPermissionStuffs();
            } else {
                if (
                    this.ActuationOperation === Number(ActuationOperation.Solicitud) ||
                    this.ActuationOperation === Number(ActuationOperation.GestionConMutua) ||
                    this.ActuationOperation === Number(ActuationOperation.InformeMedico) ||
                    this.ActuationOperation === Number(ActuationOperation.DocumentoNoMedico) ||
                    this.ActuationOperation === Number(ActuationOperation.SmsEntregado) ||
                    this.ActuationOperation === Number(ActuationOperation.SmsNoEntregado) ||
                    this.ActuationOperation === Number(ActuationOperation.PedirCita) ||
                    this.ActuationOperation === Number(ActuationOperation.CitationFormal) ||
                    this.ActuationOperation === Number(ActuationOperation.AcknowledgementOfReceipt)
                ) {
                    this.DisplayEmployeeView = true;
                } else {
                    this.DisplayEmployeeView = false;
                }
            }
        }

    }

    ngOnDestroy(): void {
        this.actuationService.UnsubcribeCurretEmployee();
    }

    ngOnInit(): void {

        this.actuationService.CurrentEmployeeSubcription = this.actuationService.currentEmployee.subscribe(res => {

            if (res) {
                this.gender = res.result.gender;
                const momentBirthDate = DateHelper.getMomentDate(res.result.birthDate);
                this.birthDate = momentBirthDate.format('DD/MM/YYYY');
                const momentToday = DateHelper.getMomentDate(null);
                this.age = momentToday.diff(momentBirthDate, 'years');
                this.city = res.result.city;

                // Address Part Begins
                const addressFirstLine: Array<string> = [];
                const addressSecondLine: Array<string> = [];
                const addressThirdLine: Array<string> = [];
                if (res.result.direction) {
                    addressFirstLine.push(res.result.direction);
                }
                if (res.result.postalCode) {
                    addressSecondLine.push(res.result.postalCode);
                }
                if (res.result.city) {
                    addressSecondLine.push(res.result.city);
                }
                if (res.result.province) {
                    addressSecondLine.push(res.result.province);
                }
                if (res.result.obsDirection) {
                    addressThirdLine.push(res.result.obsDirection);
                }

                const fullAddress = [addressFirstLine, addressSecondLine, addressThirdLine];
                this.formatedAddress = fullAddress.join('\n');

                // Anitguedad Part Begins
                if (res.result.hiringDate !== null) {
                    const momentHirigDate = DateHelper.getMomentDate(res.result.hiringDate);
                    const momentContractEndDate = DateHelper.getMomentDate(res.result.contractEndDate);
                    this.yearDiffrence = momentContractEndDate.diff(momentHirigDate, 'years');
                    const contractShouldEndYear = momentHirigDate.clone();
                    contractShouldEndYear.add(this.yearDiffrence, 'years');
                    this.monthDiffrence = momentContractEndDate.diff(contractShouldEndYear, 'months');
                    this.hiringAndContractEndDateToolTip = 'F.Antigüedad: ' + momentHirigDate.format('DD/MM/YYYY') + '.' + ' F.Fin.Contrato: ' + momentContractEndDate.format('DD/MM/YYYY');
                } else {
                    this.yearDiffrence = null;
                }

                if (this.yearDiffrence === 1) {
                    this.textFollowedByYear = 'año';
                }
                else if (this.yearDiffrence > 1) {
                    this.textFollowedByYear = 'años';
                }

                if (this.monthDiffrence === 1) {
                    this.textFollowedByMonth = 'mes';
                }
                else if (this.monthDiffrence > 1) {
                    this.textFollowedByMonth = 'meses';
                }

                if (res.result.contractEndDate !== null) {
                    const TodayDate = moment(new Date());
                    const momentContractEndDate = DateHelper.getMomentDate(res.result.contractEndDate);
                    const diffInDates = moment.duration(momentContractEndDate.diff(TodayDate)).asDays();
                    if (diffInDates <= 0) {
                        this.BaajaDeeText = 'BAJA DE EMPRESA';
                    }
                    else {
                        this.BaajaDeeText = '';
                    }
                }

                // Consentimento Line Begins
                this.consent = res.result.consent;
                this.consentType = res.result.consentType;
                if (this.consent !== null && this.consentType !== null) {

                    this.consentToShow = this.GetConsent(this.consentType, this.consent);

                    const addressArrayConssentimiento: Array<string> = [];
                    const line1 = res.result.consentRecordedDate !== null ? 'Consentimiento grabado en ' + DateHelper.getMomentDate(res.result.consentRecordedDate).format('DD/MM/YYYY') : '';
                    const line2 = res.result.consentDate !== null ? 'Consentimiento escrito en ' + DateHelper.getMomentDate(res.result.consentDate).format('DD/MM/YYYY') : '';
                    const line3 = res.result.deleverdDate !== null ? 'y entregado en ' + DateHelper.getMomentDate(res.result.deleverdDate).format('DD/MM/YYYY') : '';
                    if (line1 !== '') {
                        addressArrayConssentimiento.push(line1);
                    }
                    if (line2 !== '') {
                        addressArrayConssentimiento.push(line2);
                    }
                    if (line3 !== '') {
                        addressArrayConssentimiento.push(line3);
                    }
                    if (res.result.telCancelled) {
                        const line4 = 'Teléfono Cancelado ';
                        addressArrayConssentimiento.push(line4);
                        this.consentimentoHouverText = addressArrayConssentimiento.join('\n');
                    }
                    else {
                        this.consentimentoHouverText = addressArrayConssentimiento.join('\n');
                    }

                }

                // Telephone Line Begins
                const telephoneArray: Array<string> = [];
                if (res.result.telephone1) {
                    telephoneArray.push(res.result.telephone1);
                }
                if (res.result.telephone2) {
                    telephoneArray.push(res.result.telephone2);
                }
                if (res.result.movil) {
                    telephoneArray.push(res.result.movil);
                }
                if (res.result.telephone4) {
                    telephoneArray.push(res.result.telephone4);
                }

                this.formatedTelephoneArray = telephoneArray.length > 0 ? telephoneArray.join(' / ') : '';

                this.puesto = (res.result.position !== null) ? res.result.position : null;
            }

        });

    }

    private GetConsent(tipoConsentimiento, consentimiento): string {
        let result: string;
        switch (tipoConsentimiento) {
            case 'E':
                result = (consentimiento === 'E') ? 'Consentimiento escrito firmado' : 'Consentimiento escrito firmado y entregado';
                break;
            case 'G':
                result = 'Consentimiento grabado';
                break;
            case 'EG':
                result = (consentimiento === 'E') ? 'Consentimiento grabado, firmado y entregado' : 'Consentimiento grabado y firmado';
                break;
            default:
                {
                    if (consentimiento === 'S') {
                        result = 'Consentimiento firmado';
                    }
                    else if (consentimiento === 'E') {
                        result = 'Consentimiento firmado y entregado';
                    }
                }
                break;
        }
        return result;
    }

    private SetPermissionStuffs(): void {
        this.PermissionIds = Utils.decrypt(localStorage.getItem('permissionIds')).split(',');

        const visitaMedicoIndex = this.PermissionIds.findIndex(x => x === '524');
        if (visitaMedicoIndex === -1) {
            this.DisplayEmployeeView = false;
        } else {
            this.DisplayEmployeeView = true;
        }
    }

}
